import { useRef } from 'react';
import { useSingleton } from './singleton.js';

/**
 * create a wrapper around the given callback, making sure that it will always
 * invoke the latest provided method, regardless of whether it's being executed
 * from within a stale closure
 *
 * uses useRef under the hood to retain a reference to the latest provided
 * method
 */
function useCallbackRef(callback) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  return useSingleton(() => (...args) => callbackRef.current(...args));
}

export { useCallbackRef };
//# sourceMappingURL=callback-ref.js.map
